module.exports = __webpack_public_path__ + "static/media/AK_5.c47de276.jpeg";